import {
  GetRiskLegacyBaseModel,
  PostRiskLegacyBaseModel,
} from "@/features/risk/types/riskLegacyModel";
import { RiskBaseModel } from "@/features/risk/types/riskModels";

export const legacyRiskModelToNewModel = (items: GetRiskLegacyBaseModel[]) => {
  return items.map((item) => {
    const riskBaseModel: RiskBaseModel = {
      wbsEntryId: item.deliverableId,
      id: item.id,
      name: item.name,
      probabOfOccurrence: item.residualProbability,
      modeDuration: item.mostLikelyPerformance,
      modeEmissions: item.emissions,
      durationCost: item.mostLikelyPerformance * item.fixedCostPerDay,
      modeRemedialCost: item.mostLikelyRemedialCost,
      impactDuration: item.deterministicPerformance,
      // @todo: The calculation below should be done in the back-end
      impactCost: item.fixedDeterministicPerformanceCost + item.deterministicRemedialCost,
      impactEmissions: (item.residualProbability / 100) * item.emissions,
    };
    return riskBaseModel;
  });
};

export const legacyRiskItemToNewItem = (item: GetRiskLegacyBaseModel): RiskBaseModel => {
  const riskBaseModel: RiskBaseModel = {
    wbsEntryId: item.deliverableId,
    id: item.id,
    name: item.name,
    probabOfOccurrence: item.residualProbability,
    modeDuration: item.mostLikelyPerformance,
    modeEmissions: item.emissions,
    durationCost: item.fixedDeterministicPerformanceCost,
    modeRemedialCost: item.mostLikelyRemedialCost,
    impactDuration: item.deterministicPerformance,
    // @todo: The calculation below should be done in the back-end
    impactCost: item.fixedDeterministicPerformanceCost + item.deterministicRemedialCost,
    impactEmissions: (item.residualProbability / 100) * item.emissions,
  };
  return riskBaseModel;
};
export default function newRiskModelToLegacyModel(
  risk: RiskBaseModel
): PostRiskLegacyBaseModel {
  const riskLegacyBaseModel: PostRiskLegacyBaseModel = {
    deliverableId: risk.wbsEntryId,
    id: risk.id,
    name: risk.name,
    residualProbability: risk.probabOfOccurrence,
    mostLikelyPerformance: risk.modeDuration,
    mostLikelyRemedialCost: risk.modeRemedialCost,
    emissions: risk.modeEmissions,
  };
  return riskLegacyBaseModel;
}
